module.exports = "<table class=\"table-col-2\" cellspacing=\"0\" width=\"100%\" datatable=\"ng\" dt-options=\"reportCtrl.DataTableService.settings\">\n\t<thead>\n\t\t<tr>\n\t\t\t<th></th>\n\t\t\t<th>Pax</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr ng-repeat=\"row in reportCtrl.DataTableService.combinedData\">\n\t\t\t<td>{{ row[0] }}</td>\n\t\t\t<td>{{ row[1] }}</td>\n\t\t</tr>\n\t</tbody>\n</table>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/views/html/base-table.html
 ** module id = 173
 ** module chunks = 0
 **/